import {IModelUser} from "../../types/user";

console.log(window.location.href);
export const saveUserToStorage = (
	user: IModelUser,
	session_id?: string
): void => {
	localStorage.setItem("user", JSON.stringify(user));
	localStorage.setItem("is_authorized", "true");

	if (session_id !== undefined) {
		localStorage.setItem("sid", session_id);
	}
};

export const clearUserFromStorage = (): void => {
	localStorage.removeItem("user");
	localStorage.removeItem("is_authorized");
	localStorage.removeItem("sid");
};

export const getUserObjectFromStorage = (): IModelUser => {
	return JSON.parse(localStorage.getItem("user") || "{}");
};

export const oidcLoginButton = () => {
	const url = buildOidcLoginURL();
	const a = document.createElement("a");
	document.body.appendChild(a);
	a.href = url.toString();
	a.click();
	a.remove();
};

export const REDIRECT_URL =
	process.env.REACT_APP_SSO_REDIRECT_URL || `${window.location.origin}`;

export const buildOidcLoginURL = (): URL => {
	const SSO_DOMAIN_URL = process.env.REACT_APP_SSO_DOMAIN_URL || "";
	const GIGYA_API_KEY = process.env.REACT_APP_GIGYA_API_KEY || "";
	const SSO_CLIENT_ID = process.env.REACT_APP_SSO_CLIENT_ID || "";
	const SSO_REDIRECT_URL = REDIRECT_URL;

	const fields = [
		SSO_DOMAIN_URL,
		SSO_CLIENT_ID,
		GIGYA_API_KEY,
		SSO_REDIRECT_URL,
	];

	if (fields.some((field) => !field)) {
		throw new Error(
			"One or more of the following fields are empty: SSO_DOMAIN_URL, SSO_CLIENT_ID, GIGYA_API_KEY, SSO_REDIRECT_URL"
		);
	}

	const generateNonce = (length = 32) =>
		window.crypto?.getRandomValues
			? Array.from(window.crypto.getRandomValues(new Uint8Array(length)))
					.map((b) => b.toString(16).padStart(2, "0"))
					.join("")
			: Math.random().toString(36).substring(2) + Date.now().toString(36);

	const nonce = generateNonce();
	const url = new URL(`${SSO_DOMAIN_URL}/oidc/op/v1.0/alpha/authorize`);

	url.searchParams.append("client_id", SSO_CLIENT_ID);
	url.searchParams.append("gig_apiKey", GIGYA_API_KEY);
	url.searchParams.append("response_type", "code");
	url.searchParams.append("prompt", "login");
	url.searchParams.append("scope", "openid profile email api nfl_complete");
	url.searchParams.append("nonce", nonce);
	url.searchParams.append("redirect_uri", SSO_REDIRECT_URL);
	url.searchParams.append(
		"adobe_mc",
		window._satellite?.getVisitorId?.().getMarketingCloudVisitorID?.() || ""
	);
	url.searchParams.append("consent_config", window.OptanonActiveGroups);

	return url;
};
